import React from 'react';
import { FavoriteFilledSmall } from '@wix/wix-ui-icons-common';
import { Text, Box } from '@wix/design-system';
export function AppReviewsInfo({ reviews, skin = 'default', }) {
    return (React.createElement(Box, { dataHook: "reviews-info", verticalAlign: "middle", height: "18px", gap: "4px" },
        React.createElement(FavoriteFilledSmall, { color: reviews.totalCount === 0
                ? 'rgba(22, 45, 61, 0.2)'
                : skin === 'slim'
                    ? '#5A5A5A'
                    : '#FDB10C' }),
        React.createElement(Box, { gap: "5px", verticalAlign: "middle" },
            React.createElement(Text, { "data-hook": "average-rating", size: "tiny", weight: "bold" }, Number(reviews.averageRating).toFixed(1)),
            skin === 'default' && (React.createElement(Text, { "data-hook": "total-reviews", size: "tiny", weight: "thin", secondary: true }, `(${reviews.totalCount})`)))));
}
//# sourceMappingURL=app-reviews-Info.js.map